import { ErrorBoundary } from 'react-error-boundary';
import { Routes, Route } from 'react-router-dom';

import RouteWithTitle from '../../../../src/routes/RouteWithTitle';
import { AccessControl } from '../../../components';
import { useAtsAccess, AtsAccess } from '../../../hooks/useAtsAccess';
import ErrorLogger from '../../../providers/ErrorLogger';
import RouteGuard from '../../../routes/RouteGuard';
import { Loader } from '../../conversationWidget/components/Loader';
import AllVendorsListing from '../components';
import AddVendorList from '../components/addVendorList/AddVendorList';
import BroadCastListing from '../components/history/broadCastList/BroadCastListing';
import HistoryListing from '../components/history/HistoryListing';
import VendorSubscribedEmail from '../components/subscription/VendorSubscribedEmail';
import VendorSubscriptionPreferences from '../components/subscription/VendorSubscriptionPreferences';
import VendorUnsubscribed from '../components/subscription/VendorUnsubscribed';
import VendorListing from '../components/vendorList/vendorListing';

export const VendorsRoutes = () => {
  const isViewVendors = useAtsAccess(AtsAccess.VENDORS);

  return (
    <Routes>
      <Route
        path="/"
        element={
          <RouteWithTitle title="Vendors - Wisestep">
            <RouteGuard>
              <ErrorBoundary FallbackComponent={({ error }) => <ErrorLogger error={error} />}>
                {isViewVendors == undefined ? (
                  <Loader />
                ) : isViewVendors ? (
                  <AllVendorsListing />
                ) : (
                  <AccessControl />
                )}
              </ErrorBoundary>
            </RouteGuard>
          </RouteWithTitle>
        }
      />
      <Route
        path="/add-vendors"
        element={
          <RouteGuard>
            <ErrorBoundary FallbackComponent={({ error }) => <ErrorLogger error={error} />}>
              {/* <AddVendors /> */}
            </ErrorBoundary>
          </RouteGuard>
        }
      />
      <Route
        path="/new-vendor-list"
        element={
          <RouteWithTitle title="Vendors List - Wisestep">
            <RouteGuard>
              <ErrorBoundary FallbackComponent={({ error }) => <ErrorLogger error={error} />}>
                <AddVendorList />
              </ErrorBoundary>
            </RouteGuard>
          </RouteWithTitle>
        }
      />
      <Route
        path="/:id"
        element={
          <RouteGuard>
            <ErrorBoundary FallbackComponent={({ error }) => <ErrorLogger error={error} />}>
              <VendorListing />
            </ErrorBoundary>
          </RouteGuard>
        }
      />
      <Route
        path="/broadcast-history"
        element={
          <RouteGuard>
            <ErrorBoundary FallbackComponent={({ error }) => <ErrorLogger error={error} />}>
              <HistoryListing />
            </ErrorBoundary>
          </RouteGuard>
        }
      />
      <Route
        path="/broadcast-history/:id"
        element={
          <RouteGuard>
            <ErrorBoundary FallbackComponent={({ error }) => <ErrorLogger error={error} />}>
              <BroadCastListing />
            </ErrorBoundary>
          </RouteGuard>
        }
      />
    </Routes>
  );
};
export const VendorPublicRoutes = () => (
  <Routes>
    <Route
      path="/subscription"
      element={
        <RouteGuard>
          <ErrorBoundary FallbackComponent={({ error }) => <ErrorLogger error={error} />}>
            <VendorSubscriptionPreferences />
          </ErrorBoundary>
        </RouteGuard>
      }
    />
    <Route
      path="/subscribed"
      element={
        <RouteGuard>
          <ErrorBoundary FallbackComponent={({ error }) => <ErrorLogger error={error} />}>
            <VendorSubscribedEmail />
          </ErrorBoundary>
        </RouteGuard>
      }
    />
    <Route
      path="/unsubscribe"
      element={
        <RouteGuard>
          <ErrorBoundary FallbackComponent={({ error }) => <ErrorLogger error={error} />}>
            <VendorUnsubscribed />
          </ErrorBoundary>
        </RouteGuard>
      }
    />
  </Routes>
);
